import _, { get, isEmpty, isNil, uniqueId } from 'lodash';
import { v4 as uuidV4 } from 'uuid';
import { LAWYER_ASSIGNMENTS_LABELS } from 'containers/LawyerAssignmentsPage/constants';
import {
  CLAIM_STATUSES,
  ListProceeding,
  rcCoporeal,
  RC_CORPOREAL_DAMAGE_CAUSED_TO_THIRD_PARTIES,
} from 'containers/CourtManagerLegalProceedings/constants';
import { VehicleForm } from 'containers/CourtManagerLegalProceedings/typings';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { resolveSagisClaim } from 'helpers/utils';
import { DEFAULT_INTERVENANT_CODE } from 'containers/RecapPage/canstants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { ALL_STATUS } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/constants';
import { COLORS } from 'constants/design';
import { FEATURES } from 'features/features';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import * as featureService from 'features/fflip-helpers';
import {
  formatCourtFileNumber,
  validationCourtFileNumber,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { SagisConfig } from 'containers/AppContainer/typings';
import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  LISTINGS,
  VICTIM,
} from 'containers/data-structure';
import { getAssignedJurisdictionLawyerCode } from 'containers/RecapManagerPage/utils';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  addPriorityReasonProfession,
  removeWhiteSpaceFromString,
  validationVehicle,
} from 'services/utils';
import {
  checkClassVictims,
  checkVictimsAge,
  isUniqueCinAddedVictims,
} from 'containers/PreOpeningPage/utils';
import { translate } from 'containers/services/translate';
import { VictimType } from 'typings/globalTypes';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { formatLabel } from 'helpers/utils';
import { ClaimRecapType } from 'typings/claimTypes';

export const resolveSteps = (steps: string[]) => {
  const judgementAdd = steps.find(
    (el: string) => el === LAWYER_ASSIGNMENTS_LABELS[1],
  );
  const expertReport = steps.find(
    (el: string) => el === LAWYER_ASSIGNMENTS_LABELS[2],
  );
  const judgementOnTheMerits = steps.find(
    (el: string) => el === LAWYER_ASSIGNMENTS_LABELS[3],
  );
  const appeal = steps.find(
    (el: string) => el === LAWYER_ASSIGNMENTS_LABELS[4],
  );
  return [
    LAWYER_ASSIGNMENTS_LABELS[0],
    judgementAdd,
    expertReport,
    judgementOnTheMerits,
    appeal,
  ].filter(el => el !== undefined);
};

export const getRiskIdFromPolicyInfo = (policyInfo: any) =>
  get(resolveSagisClaim(policyInfo), 'offeredRisks', []).find(
    (offeredRisk: any) =>
      offeredRisk.riskName === RC_CORPOREAL_DAMAGE_CAUSED_TO_THIRD_PARTIES,
  )?.riskId;

export const formatOpposingParties = (
  vehiculeForms: VehicleForm[],
  riskId: string,
  claimNumber: string,
  claimId: number,
  insuranceCompanieslist: any,
) => {
  return vehiculeForms.map((vehiculeForm: VehicleForm) => {
    return _formatOpposingParty(
      vehiculeForm,
      riskId,
      claimNumber,
      claimId,
      insuranceCompanieslist,
    );
  });
};

export const _formatOpposingParty = (
  vehiculeForm: VehicleForm,
  riskId: string,
  claimNumber: string,
  claimId: number,
  insuranceCompanieslist: any,
) => ({
  brand: vehiculeForm.brand,
  firstName: vehiculeForm.firstName,
  lastName: vehiculeForm.lastName,
  RiskID: riskId,
  claimNumber,
  claimId,
  registrationNumber: vehiculeForm.registrationNumber,
  insuranceCompanyCode: vehiculeForm.opposingParty,
  insuranceCompanyName: getValueByCode(
    vehiculeForm.opposingParty,
    insuranceCompanieslist,
  ),
});

export const proceedingTabs = (labelsInstance: any) => {
  const tabsWithFeatures = Object.entries(labelsInstance)
    .filter(([key, value]: any) => {
      return value.feature === true;
    })
    .reduce((acc: any, [key, value]) => ((acc[key] = value), acc), {});

  return {
    currentTabIndex: get(tabsWithFeatures['FIRST_INSTANCE'], 'id'),
    labels: Object.values(tabsWithFeatures).map((e: any) => e.title),
  };
};
export const claimTabs = (labels: any) => {
  const tabsWithFeatures = Object.entries(labels)
    .filter(([key, value]: any) => {
      return value.feature === true;
    })
    .reduce((acc: any, [key, value]) => ((acc[key] = value), acc), {});

  return {
    currentTabIndex: get(tabsWithFeatures['SUMMARY'], 'id'),
    labels: Object.values(tabsWithFeatures).map((e: any) => e.title),
  };
};
export const filterVictim = (victims: any) => {
  return victims && victims.filter((element: any) => !isNil(element.victimKey));
};
export const filterVehicle = (vehicles: any) => {
  return (
    vehicles &&
    vehicles.filter(
      (element: any) =>
        element.partKey ||
        (!element.partKey && element.decision?.status != 'REJECTED'),
    )
  );
};
export const resolveExpertiseType = (type: any) => {
  switch (type) {
    case 1:
      return 'Medecin';
    case 2:
      return 'Comptables';
    case 3:
      return 'Mecaniques';
    default:
      return 'Medecin';
  }
};
export const extractExpertCode = (experts: any) => {
  return experts.map((element: any) =>
    get(element, 'attributes.sagis_code[0]', '').toString(),
  );
};
export const extractUpdatedDocument = (documents: []) => {
  return documents.map((el: any) => ({
    url: el.url,
    type: el.type,
    name: el.name,
  }));
};
export const formatPayloadAddJudiciaryProcess = (
  claimId: number,
  riskKey: string,
  civilProceedingInfo: any,
  claimNumber: string,
  procedureType: number,
  civilProceedingDoc: any,
  claimType: any,
  formattedVictims: any,
  associatedVictims: any,
  damage: any,
  riskId: string,
  victimFormValues: any,
  listings: any,
  otherDamage: any,
  associatedOpposingParties: any,
  vehicleFormValues: any,
  lossDate: any,
  priorityReasonClaimId: any = null,
) => {
  const date = new Date(lossDate);
  const dayOfMonth = date.getDate();
  const lawyerJurisdictionAssignedCode = featureService.hasFeature(
    FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
  )
    ? getAssignedJurisdictionLawyerCode(
        get(listings, LISTINGS.MAPPING_LAWYER_JURISDICTION, []),
        civilProceedingInfo.town,
        dayOfMonth,
      )
    : '';
  return {
    claimId: claimId,
    riskKey: riskKey,
    circonscription: civilProceedingInfo.circonscription,
    isTrackingActive: featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER),
    assignedLawyer: featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? lawyerJurisdictionAssignedCode
      : civilProceedingInfo.assignedLawyer,
    procedureNatureId: procedureType,
    town: civilProceedingInfo.town,
    claimNumbers: claimNumber,
    opposingLawyer: civilProceedingInfo.opposingLawyer,
    jurisdictionDegreeId: civilProceedingInfo.jurisdictionDegreeId,
    receptionDate: civilProceedingInfo.receptionDate,
    hearingDate: civilProceedingInfo.hearingDate,
    documents: civilProceedingDoc,
    courtNumber: formatCourtFileNumber(civilProceedingInfo.courtNumber),
    assignedLawyers: featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? [lawyerJurisdictionAssignedCode]
      : civilProceedingInfo.assignedLawyers,
    intervenantSagis: featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? [
          {
            intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
            intervenantCode: lawyerJurisdictionAssignedCode,
          },
        ]
      : get(civilProceedingInfo, 'assignedLawyers').map((element: any) => ({
          intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
          intervenantCode: element,
        })),
    assignementDetails: {
      contractorFees: featureService.hasFeature(
        FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
      )
        ? [
            {
              uniqueId: uniqueId(),
              contractorTypeCode: DEFAULT_INTERVENANT_CODE,
              contractorCode: lawyerJurisdictionAssignedCode,
              amount: 0,
              isPayment: false,
            },
          ]
        : get(civilProceedingInfo, 'assignedLawyers').map((element: any) => ({
            uniqueId: uniqueId(),
            contractorTypeCode: DEFAULT_INTERVENANT_CODE,
            contractorCode: element,
            amount: 0,
            isPayment: false,
          })),
      uuid: uuidV4(),
    },
    victims: claimType.corporeal
      ? [
          ...Object.values(victimFormValues).map((el: any) => {
            return {
              ...el,
              itt: el.itt === '' ? null : el.itt,
              annualOfIncome:
                el.annualOfIncome === '' ? null : el.annualOfIncome,
              isExcluded: !!el.isExcluded,
              id: undefined,
              beneficiaries: el.beneficiaries.map((item: any) => ({
                ...item,
                funeralFees:
                  item.funeralFees === '' ? undefined : item.funeralFees,
              })),
            };
          }),
        ]
      : undefined,
    priorityReasonId: addPriorityReasonProfession(
      priorityReasonClaimId,
      !!Object.values(victimFormValues).find((v: any) =>
        PROFESSION_CODES.includes(v.professionCode),
      ),
      listings,
    ),
    victimsSagis: formattedVictims,
    associatedVictims,
    username: currentUserStorage.get().username,
    otherDamage: damage.otherProperties ? otherDamage : undefined,
    updateSagisIntervenantProvision: featureService.hasFeature(
      FEATURES.EVOLUTION_P3,
    )
      ? false
      : true,
    opposingParties: damage.adverseVehicles
      ? formatOpposingParties(
          Object.values(vehicleFormValues),
          riskId,
          claimNumber,
          claimId,
          listings?.compagnies,
        )
      : undefined,
    associatedOpposingParties,
    isAutomaticAssignement: featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    ),
    status: ALL_STATUS.VALIDATED,
    creator: currentUserStorage.get().username,
    isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
  };
};

export const renderColor = (claimNature: string) => {
  switch (claimNature) {
    case 'Transaction':
      return COLORS.YELLOW;
    case 'Judiciaire':
      return COLORS.GREEN;
    case 'Hybride':
      return COLORS.RED;
    default:
      return COLORS.YELLOW;
  }
};

export const isLockedClaim = (policyInfo: any) => {
  return (
    get(resolveSagisClaim(policyInfo), 'isLocked') === true &&
    get(resolveSagisClaim(policyInfo), 'lockedBy', null) &&
    featureService.hasFeature(FEATURES.MANAGER_LOCK_CLAIM) &&
    get(currentUserStorage.get(), 'privileges.sagisName') !=
      get(resolveSagisClaim(policyInfo), 'lockedBy', null)
  );
};

export const isBlockStatusClaim = (policyInfo: any) => {
  return (
    !isNil(get(resolveSagisClaim(policyInfo), 'status', null)) &&
    (get(resolveSagisClaim(policyInfo), 'status') === CLAIM_STATUSES.CANCELED ||
      get(resolveSagisClaim(policyInfo), 'status') === CLAIM_STATUSES.CLOSED ||
      get(resolveSagisClaim(policyInfo), 'status') ===
        CLAIM_STATUSES.NOFOLLOWUP ||
      get(resolveSagisClaim(policyInfo), 'status').includes(
        CLAIM_STATUSES.NOFOLLOWUP,
      )) &&
    featureService.hasFeature(FEATURES.STATUS_MANAGEMENT)
  );
};

export const filterFeeNotes = (
  feeNotes: any,
  isExpertiseFeeNote: any,
  judgementDecisonIds: any,
  isDecisionFeeNote: boolean,
) => {
  if (isExpertiseFeeNote && !isDecisionFeeNote) {
    return feeNotes;
  } else {
    if (
      isDecisionFeeNote &&
      featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)
    ) {
      if (
        !isNil(get(judgementDecisonIds, 'judgementId', null)) &&
        !isNil(get(judgementDecisonIds, 'judgementAddDocumentId', null))
      ) {
        const filtredData = feeNotes.filter(
          (el: any) =>
            el.judgementId === get(judgementDecisonIds, 'judgementId', null) ||
            el.judgementAddDocumentId ===
              get(judgementDecisonIds, 'judgementAddDocumentId', null),
        );
        if (!isEmpty(filtredData)) {
          return filtredData;
        } else {
          return [];
        }
      }
      if (!isNil(get(judgementDecisonIds, 'judgementId', null))) {
        const filtredData = feeNotes.filter(
          (el: any) =>
            el.judgementId === get(judgementDecisonIds, 'judgementId', null),
        );
        if (!isEmpty(filtredData)) {
          return filtredData;
        } else {
          return [];
        }
      } else if (
        !isNil(get(judgementDecisonIds, 'judgementAddDocumentId', null))
      ) {
        return feeNotes.filter(
          (el: any) =>
            el.judgementAddDocumentId ===
            get(judgementDecisonIds, 'judgementAddDocumentId', null),
        );
      } else if (!isNil(get(judgementDecisonIds, 'missionExpertiseId', null))) {
        const filtredData = feeNotes.filter(
          (el: any) =>
            el.feeNoteMission?.missionExpertiseVictim?.id ===
            get(judgementDecisonIds, 'missionExpertiseId', null),
        );
        if (!isEmpty(filtredData)) {
          return filtredData;
        } else {
          return [];
        }
      } else if (!isNil(get(judgementDecisonIds, 'missionPostPoneId', null))) {
        const filtredData = feeNotes.filter(
          (el: any) =>
            el.feeNoteMission?.missionPostPone?.id ===
            get(judgementDecisonIds, 'missionPostPoneId', null),
        );
        if (!isEmpty(filtredData)) {
          return filtredData;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } else {
      return feeNotes;
    }
  }
};
export const insensitiveCaseComparaison = (string1: string, string2: string) =>
  string1?.toUpperCase() === string2?.toUpperCase();

export const getNextAvailableStatuses = (currentStatus: string) => {
  if (insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.ACTIVATION)) {
    return [CLAIM_STATUSES.NOFOLLOWUP];
  } else if (
    insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.REOPEN) ||
    insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.INPROGRESS) ||
    insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.PREACTIVATION)
  ) {
    return [CLAIM_STATUSES.NOFOLLOWUP, CLAIM_STATUSES.CLOSED];
  } else if (
    insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.CLOSED) ||
    insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.FIXED) ||
    insensitiveCaseComparaison(currentStatus, CLAIM_STATUSES.NOFOLLOWUP) ||
    currentStatus.includes(CLAIM_STATUSES.NOFOLLOWUP)
  ) {
    return [CLAIM_STATUSES.REOPEN];
  }
  return [];
};
export const isOtherProfession = (professions: SagisConfig[], itemKey: any) => {
  const profession = professions.find(item => item.ItemKey === itemKey) || {};
  return get(profession, 'ItemKey', '') === '144' ? true : false;
};

export const disabledDialogAddVictim = (
  victimAddFormValues: any,
  claimRecap: ClaimRecapType,
) => {
  return (
    !isUniqueCinAddedVictims(
      get(claimRecap, 'victims', []),
      Object.values(victimAddFormValues),
      get(claimRecap, 'claim.lossDate'),
    ) ||
    checkClassVictims(
      [...Object.values(victimAddFormValues)],
      get(claimRecap, 'claim.lossDate'),
    ) ||
    checkVictimsAge(
      [...Object.values(victimAddFormValues)],
      get(claimRecap, 'claim.lossDate'),
    )
  );
};

export const disabledPrimaryButton = (
  claimType: any,
  associatedVictims: any,
  victimFormValues: any,
  associatedOpposingParties: any,
  vehicleFormValues: any,
  civilProceedingInfo: any,
) => {
  return (
    (claimType.corporeal && !claimType.material
      ? isEmpty(associatedVictims) && isEmpty(victimFormValues)
      : !claimType.corporeal && claimType.material
      ? (isEmpty(associatedOpposingParties) && isEmpty(vehicleFormValues)) ||
        (!isEmpty(vehicleFormValues) &&
          !validationVehicle(Object.values(vehicleFormValues)))
      : (isEmpty(associatedVictims) && isEmpty(victimFormValues)) ||
        (isEmpty(associatedOpposingParties) && isEmpty(vehicleFormValues)) ||
        (!isEmpty(vehicleFormValues) &&
          !validationVehicle(Object.values(vehicleFormValues)))) ||
    !validationCourtFileNumber(
      get(
        civilProceedingInfo,
        [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER],
        '',
      ),
    ) ||
    isNil(
      get(
        civilProceedingInfo,
        [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.TOWN],
        null,
      ),
    )
  );
};

export const formatSagisVictimsForValidationJudiciaryProcess = (
  victimFormValues: {
    [key: string]: VictimType;
  },
  claimResponsabilityRate: String,
  listings: any,
) => {
  return [...Object.values(victimFormValues)].map((victim: VictimType) => {
    let setDefaultBirthDate = false;
    if (victim[VICTIM.DATE_OF_BIRTH] === 'Invalid Date') {
      setDefaultBirthDate = true;
    }
    if (victim.injuryPostKey === INJURY_POST_DECEASED) {
      victim.nextOfKins = victim.beneficiaries.map((el: any) => {
        return {
          fullName: `${removeWhiteSpaceFromString(
            el.firstName,
          )} ${removeWhiteSpaceFromString(el.lastName)}`,
          qualityCode: Number(el.beneficiaryType),
          age: el.age,
          birthDate: el?.dateOfBirth,
          funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
            ? el.funeralFees
            : !isNil(el.funeralFees) && !!Number(claimResponsabilityRate)
            ? el.funeralFees / (Number(claimResponsabilityRate) / 100)
            : el.funeralFees,
          handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
          dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
        };
      });
    }
    return {
      ...victim,
      id: undefined,
      victimFirstName: victim[VICTIM.FIRST_NAME],
      victimLastName: victim[VICTIM.LAST_NAME],
      victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
      injuryCode:
        String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
          ? victim[VICTIM.INJURY_POST_KEY]
          : 0,
      qualityVictim: victim[VICTIM.QUALITY_KEY],
      classVictim: victim[VICTIM.CLASS_KEY],
      Town: victim[VICTIM.CITY],
      isExcluded: false,
      Complement: victim[VICTIM.ADDRESS],
      isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1 ? true : false,
      setDefaultBirthDate,
      responsibilityShare: claimResponsabilityRate,
      responsibilityRate: claimResponsabilityRate,
      cspCode: get(
        get(listings, 'Profession', []).find(
          (el: any) => el.ItemKey === victim.professionCode,
        ),
        'ItemGroup',
        null,
      ),
      gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
      itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
      annualOfIncome:
        ((victim.annualOfIncome as unknown) as string) === ''
          ? null
          : victim.annualOfIncome,
      annualInCome:
        ((victim.annualOfIncome as unknown) as string) === ''
          ? undefined
          : victim.annualOfIncome,
    };
  });
};
export const renderTabsTitle = (props: any) => {
  return {
    SUMMARY: {
      id: 0,
      title: translate(messages.courtManagerRecapTitle, props),
      feature: true,
    },
    JUDICIARY_PROCESS: {
      id: 1,
      title: translate(messages.judiciaryProcessTabTitle, props),
      feature: true,
    },
    PROVISION_AND_REGULATION: {
      id: 1,
      title: translate(messages.provisionTab, props),
      feature: featureService.hasFeature(FEATURES.PROVISION),
    },
    EXPERT_INTEGRATION: {
      id: 1,
      title: translate(messages.expertise, props),
      feature: featureService.hasFeature(FEATURES.EXPERT_INTEGRATION),
    },
    TRANSACTION: {
      id: 1,
      title: translate(messages.transactionTabTitle, props),
      feature: featureService.hasFeature(FEATURES.TRANSACTION),
    },
  };
};

export const getClaimInfoSagis = (policyInfo: any) => {
  const claimInfo =
    policyInfo &&
    get(resolveSagisClaim(policyInfo), 'offeredRisks', []).find(
      (element: { riskName: string }) => element.riskName === rcCoporeal,
    );

  return {
    responsibilityRate: claimInfo?.responsibilityRate,
    riskKey: claimInfo?.riskId,
  };
};

export const getLabelsWithLabelsIds = (civilProceeding: any) => {
  let labes = _.orderBy(civilProceeding, ['procedureNatureId'], ['desc']).map(
    (
      el: {
        procedureNatureId: number;
        id: number;
        courtNumber: string;
      },
      index,
    ) =>
      formatLabel(
        get(
          ListProceeding.filter(element => element.id === el.procedureNatureId),
          '[0].title',
        ),
        el.courtNumber,
        el.procedureNatureId === 3 ? false : true,
      ),
  );

  let labesWithIds = _.orderBy(
    civilProceeding,
    ['procedureNatureId'],
    ['desc'],
  ).map(
    (
      el: {
        procedureNatureId: number;
        id: number;
        courtNumber: string;
      },
      index,
    ) => {
      return {
        id: el.id,
        label: formatLabel(
          get(
            ListProceeding.filter(
              element => element.id === el.procedureNatureId,
            ),
            '[0].title',
          ),
          el.courtNumber,
          el.procedureNatureId === 3 ? false : true,
        ),
      };
    },
  );
  return {
    labes,
    labesWithIds,
  };
};

export const getCourtFileNumber = (
  civilProceeding: any,
  idCivilProceeding: number,
  judgementAdd: any,
) => {
  const correctionnelProceeding = civilProceeding.find(
    (element: { procedureNatureId: number; id: number }) =>
      element.procedureNatureId === 3 && element.id === idCivilProceeding,
  );
  if (!_.isEmpty(correctionnelProceeding)) {
    return get(judgementAdd, 'judgementAdd.courtFile', '');
  } else {
    const selectedCivilProcceding = civilProceeding.find(
      (element: { procedureNatureId: number; id: number }) =>
        element.id === idCivilProceeding,
    );
    return get(selectedCivilProcceding, 'courtNumber', '');
  }
};
export const formatSagisVictimsForAddVictim = (
  victimFormValues: VictimType[],
  claimResponsabilityRate: String,
  listings: any,
) => {
  return victimFormValues.map((victim: VictimType) => {
    let setDefaultBirthDate = false;
    if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
      setDefaultBirthDate = true;
    }
    if (victim.injuryPostKey === INJURY_POST_DECEASED) {
      victim.nextOfKins = victim.beneficiaries.map((el: any) => {
        return {
          fullName: `${removeWhiteSpaceFromString(
            el.firstName,
          )} ${removeWhiteSpaceFromString(el.lastName)}`,
          qualityCode: Number(el.beneficiaryType),
          age: el.age,
          birthDate: el?.dateOfBirth,
          funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
            ? el.funeralFees
            : !isNil(el.funeralFees) && !!Number(claimResponsabilityRate)
            ? el.funeralFees / (Number(claimResponsabilityRate) / 100)
            : el.funeralFees,
          handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
          dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
        };
      });
    }

    return {
      ...victim,
      victimFirstName: victim[VICTIM.FIRST_NAME],
      victimLastName: victim[VICTIM.LAST_NAME],
      victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
      injuryCode:
        String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
          ? victim[VICTIM.INJURY_POST_KEY]
          : 0,
      qualityVictim: victim[VICTIM.QUALITY_KEY],
      classVictim: victim[VICTIM.CLASS_KEY],
      Town: victim[VICTIM.CITY],
      isExcluded: false,
      Complement: victim[VICTIM.ADDRESS],
      responsibilityShare: claimResponsabilityRate,
      responsibilityRate: claimResponsabilityRate,
      isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
      setDefaultBirthDate,
      cspCode: get(
        get(listings, 'Profession', []).find(
          (el: any) => el.ItemKey === victim.professionCode,
        ),
        'ItemGroup',
        null,
      ),
      gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
      itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
      annualOfIncome:
        ((victim.annualOfIncome as unknown) as string) === ''
          ? null
          : victim.annualOfIncome,
      annualInCome:
        ((victim.annualOfIncome as unknown) as string) === ''
          ? undefined
          : victim.annualOfIncome,
    };
  });
};
export const getVictimNamesWithJudgement = (list: any, claimVictims: any) => {
  const victimIdsWithJudgement = _.chain(list)
    .filter(item => _.values(item)[0]?.hasJudgement)
    .map(item => _.keys(item)[0])
    .value();

  const victimNames = _.chain(claimVictims)
    .filter(v => victimIdsWithJudgement.includes(String(v.id)))
    .map((el: any) => el.firstName + ' ' + el.lastName)
    .join(', ')
    .value();
  return victimNames;
};

export const getVictimNamesWithTransaction = (list: any, claimVictims: any) => {
  const victimIdsWithJudgement = _.chain(list)
    .filter(item => _.values(item)[0]?.hasTransaction)
    .map(item => _.keys(item)[0])
    .value();

  const victimNames = _.chain(claimVictims)
    .filter(v => victimIdsWithJudgement.includes(String(v.id)))
    .map((el: any) => el.firstName + ' ' + el.lastName)
    .join(', ')
    .value();
  return victimNames;
};
